import api from 'config/api';
import requester from 'utils/requester';
import { FETCH, FETCH_ERROR, FETCH_SUCCESS, RESET_QUERY } from './action-types';
import { selectSearchQuery } from './selectors';

export const fetchSearch = (query: string) => async (dispatch, getState) => {
  dispatch({ type: FETCH, payload: query });

  try {
    const channelSearchResults = await requester({
      method: 'get',
      url: `${api.host}${api.endpoints.assets}`,
      params: {
        'type[in]': 'channel',
        $expand: `resources(url),entitlement`,
        $limit: 20,
        $offset: 0,
        $match: query,
      },
    });

    const vodSearchResults = await requester({
      method: 'get',
      url: `${api.host}${api.endpoints.assets}`,
      params: {
        'type[in]': 'movie',
        $expand: `resources(url),entitlement`,
        $limit: 20,
        $offset: 0,
        $match: query,
      },
    });

    const programsSearchResults = await requester({
      method: 'get',
      url: `${api.host}${api.endpoints.liveEvents}`,
      params: {
        $expand: `resources(url),entitlement`,
        'catchup[eq]': 1,
        $limit: 20,
        $offset: 0,
        $match: query,
      },
    });

    const currentQuery = selectSearchQuery(getState());
    /* Когда пользователь последовательно вводит символы может начаттся "гонка" запросов
     * на каждый ввод нового символа.
     * Для избежания перезаписи результата ответом на прошлый запрос (он мог позже вернуться)
     * нужно проверить, что "query" по которому был ответ все еще соответствует
     * текущему "query" в сторе.
     */
    if (query !== currentQuery) return;
    const payload = {
      vod: vodSearchResults.data,
      channels: channelSearchResults.data,
      programs: programsSearchResults.data,
    };
    dispatch(onFetchSuccess(payload));
  } catch (error) {
    dispatch(onFetchError(error));
  }
};

const onFetchSuccess = (payload) => ({
  type: FETCH_SUCCESS,
  payload,
});

const onFetchError = (payload) => ({
  type: FETCH_ERROR,
  payload,
});

export const resetSearchQuery = (payload) => ({
  type: RESET_QUERY,
  payload,
});
